import { Radio } from "../common";

const ServiceRadioGroup = ({ items = [], activedIndex = 0, onSelect }) => {
  return (
    <div className="grid lg:grid-cols-2 grid-cols-1 gap-3">
      {items.map((item, index) => (
        <Radio
          key={index}
          actived={activedIndex === index}
          className="rounded-[16px]"
          onClick={() => onSelect(index)}
        >
          <h3 className="font-semibold text-left">{item.name}</h3>
          <div className="mt-1 w-full flex flex-row items-center justify-between">
            <span className="text-dark-blue text-sm">{item.duration} min</span>
            <span className="text-primary font-bold">₪{item.price}</span>
          </div>
        </Radio>
      ))}
    </div>
  );
};

export default ServiceRadioGroup;
